export default {
  comments: [],
  pagination: {},
  comment: {}
}
